'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.head');

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Parses Rails errors, so they can be used on the client side.
 */
var RailsErrors = function () {
  function RailsErrors(errors) {
    _classCallCheck(this, RailsErrors);

    this.errors = errors;
  }

  /**
   * Returns the list of fields with errors.
   *
   * @returns {Array<string>}
   */


  _createClass(RailsErrors, [{
    key: 'forField',


    /**
     * Gets the error messages for an specific field.
     * If the field have more than one error message, they will be joined by a comma.
     *
     * @param fieldName the field name
     * @returns {string} the message (or messages) for the field
     */
    value: function forField(fieldName) {
      var msgs = (0, _lodash2.default)(this.errors, fieldName);
      if (!msgs) return;

      if (!Array.isArray(msgs)) msgs = [msgs];

      msgs = msgs.map(this.fixErrorMessage);

      return msgs.join(', ');
    }

    /**
     * Performs adjustments on the error messages.
     *
     * @param msg the error message
     * @returns {string} the fixed error message
     */

  }, {
    key: 'fixErrorMessage',
    value: function fixErrorMessage(msg) {
      msg = String(msg);

      // removes a leading '^' on the message
      if (msg && msg.substr(0, 1) === '^') msg = msg.substr(1);

      return msg;
    }
  }, {
    key: 'fields',
    get: function get() {
      return Object.keys(this.errors);
    }

    /**
     * Returns the first error message.
     *
     * @returns {string} the first error message, or undefined if there's none
     */

  }, {
    key: 'firstMessage',
    get: function get() {
      var firstField = (0, _lodash4.default)(this.fields);
      return firstField && this.forField(firstField);
    }
  }]);

  return RailsErrors;
}();

exports.default = RailsErrors;
